
const EyeIcon = (props: any = {}) => {
    return (
        <svg width="16" height="16" {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M10.1099 8.03769C10.1099 9.20169 9.16586 10.145 8.00186 10.145C6.83786 10.145 5.89453 9.20169 5.89453 8.03769C5.89453 6.87302 6.83786 5.92969 8.00186 5.92969C9.16586 5.92969 10.1099 6.87302 10.1099 8.03769Z" stroke="#0DCECE" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M8.00029 12.9054C10.539 12.9054 12.861 11.0801 14.1683 8.03743C12.861 4.99477 10.539 3.16943 8.00029 3.16943H8.00296C5.46429 3.16943 3.14229 4.99477 1.83496 8.03743C3.14229 11.0801 5.46429 12.9054 8.00296 12.9054H8.00029Z" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default EyeIcon